<template>
  <div style="width: 100%">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          <a v-if="hasOpenDetailListener()" @click.stop="emitOpenDetail"> {{ item.title }} </a>
          <span v-else> {{ item.titleReadable || item.title }} </span>
        </v-list-item-title>
        <v-list-item-subtitle v-if="!small && (item.startDate || item.endDate)">
          <span>
            {{ item.startDate | simpleDoubleDigitDate }}
          </span>
          <span v-if="item.startDate && item.endDate"> - </span>
          <span>
            {{ item.endDate | simpleDoubleDigitDate }}
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script lang="ts">
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { LeasingContract } from "@/models/leasingContract";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import { IContract } from "@/models/contract.entity";

@Component({
  components: {},
  filters: { simpleDoubleDigitDate }
})
export default class RefsContract extends Vue implements IRefDetail<LeasingContract | IContract> {
  @Prop()
  item!: LeasingContract | IContract;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  emitOpenDetail() {
    this.$emit("openDetail", this.item);
  }

  async goToDetail() {
    const goTo = (this.item as IContract).goTo;
    if (goTo) {
      goTo(this.$router).detail();
    }
  }
}
</script>
<style lang="css" scoped>
.hoverCurserMouse :hover {
  cursor: pointer;
}
</style>
